<template>
  <div class="menu-contact-user">
    <div class="message-input">
      <span
        v-if="isLabel"
        class="pointer input-label"
        @click="$emit('sendLastPrice')"
      >{{ $t('ad.item.last.price.text') }}</span>
      <send-message
        :small-input="true"
        :append-data="appendData"
        @done="$emit('done')"
      />
    </div>
    <div>
      <a
        v-if="phone"
        :href="`tel://${phone}`"
        target="_self"
        class="icon-phone-receiver phone m-t-xs-5"
        icon="icon-phone-receiver"
        circle
      />
    </div>
  </div>
</template>

<script>
  import SendMessage from '@/components/Ads/SendMessage';
  import { mapState } from 'vuex';

  export default {
    components: {
      SendMessage,
    },
    props: {
      // eslint-disable-next-line vue/require-default-prop,vue/require-prop-types
      isLabel: {},
      // eslint-disable-next-line vue/require-prop-types
      showMessageBox: {
        default: true,
      },
      // eslint-disable-next-line vue/require-default-prop,vue/require-prop-types
      phone: {},
      appendData: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        window,
      };
    },
    computed: {
      ...mapState({
        user: state => state.auth.user,
      }),
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mobile/MenuContactUser.vue